"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataType;
(function (DataType) {
    DataType["identificationHeader"] = "IdentificationHeader";
    DataType["theft"] = "Theft";
    DataType["nivIdentification"] = "NivIdentification";
    DataType["financingRug"] = "FinancingRug";
})(DataType || (DataType = {}));
exports.default = DataType;
